import type { AdvisorDto } from '@toga/shared'

/** Tope de negocio de la comisión del asesor: 30 % (fracción 0.30). */
export const MAX_ADVISOR_COMMISSION_PCT = 30

/** Acepta cualquier envoltura razonable de la lista de asesores del backend. */
export function normalizeAdvisorList(resp: unknown): AdvisorDto[] {
  if (Array.isArray(resp)) return resp as AdvisorDto[]
  const r = resp as { items?: AdvisorDto[]; advisors?: AdvisorDto[] } | null
  return r?.items ?? r?.advisors ?? []
}

/** Fracción (0.05) → texto de porcentaje editable ("5"). */
export function fractionToPctInput(fraction: number | null | undefined): string {
  if (fraction == null) return ''
  return String(Math.round(fraction * 100 * 100) / 100)
}

/** Texto de porcentaje ("5" / "5,5") → fracción (0.05 / 0.055), o null si vacío. */
export function pctInputToFraction(text: string): number | null {
  const t = text.trim().replace(',', '.')
  if (!t) return null
  const n = Number(t)
  if (!Number.isFinite(n)) return null
  return Math.round((n / 100) * 10000) / 10000
}

/** ¿El texto de porcentaje supera el tope del 30 %? */
export function isOverCommissionCap(text: string): boolean {
  const t = text.trim().replace(',', '.')
  if (!t) return false
  const n = Number(t)
  return Number.isFinite(n) && n > MAX_ADVISOR_COMMISSION_PCT
}
